import { Outlet, createFileRoute } from "@tanstack/react-router";

import { m } from "@/paraglide/messages.js";

/** Gives every client page its "Clients" breadcrumb step: Clients > Adam Nowak. */
export const Route = createFileRoute("/(private)/trainees")({
  loader: () => ({ crumb: m.booking_clients_page_title() }),
  component: Outlet,
});
